import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetCurrentAccountSuccessAction } from '../../actions/current-account/get-current-account-success-action';
import { GetCurrentAccountErrorAction } from '../../actions/current-account/get-current-account-error-action';
import { GetCurrentAccountAction } from '../../actions/current-account/get-current-account-action';

@Injectable()
export class GetCurrentAccountEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetCurrentAccount = createEffect(() => this.actions
    .pipe(
      ofType(GetCurrentAccountAction.type),
      mergeMap(() => {
        return this.api.getCurrentAccount().then(user => {
          return new GetCurrentAccountSuccessAction(user);
        }, error => {
          return new GetCurrentAccountErrorAction(error);
        });
      })
    ));
}
